import {
  DarkMode,
  DarkModeOutlined,
  DarkModeRounded,
  LightMode,
  LightModeOutlined,
} from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../_api/auth";
import { schoolYearController } from "../../_api/controllers/scolarite.controller.ts";
import { useQuery } from "@tanstack/react-query";
type HeaderProps = {
  isDarkMode: boolean;
  setIsDarkMode: React.Dispatch<React.SetStateAction<boolean>>;
  toggleDarkMode: () => void;
  currentYear: string;
  isYearDropdownOpen: boolean;
  toggleYearDropdown: () => void;
  setCurrentYear: (year: string) => void;
  setIsYearDropdownOpen: (isOpen: boolean) => void;
};

const Header = ({
  isDarkMode,
  toggleDarkMode,
  currentYear,
  isYearDropdownOpen,
  setCurrentYear,
  setIsYearDropdownOpen,
  toggleYearDropdown,
}: HeaderProps) => {
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const toggleUserMenu = () => {
    setIsUserMenuOpen(!isUserMenuOpen);
  };
  //Handle mouse click outside for dropdowns
  const MenuDropdownRef = React.useRef<HTMLDivElement>(null);

  //fetch anne scolaire
  const { data: schoolYear } = useQuery({
    queryKey: ["schoolYears"],
    queryFn: schoolYearController.getAll,
  });
  const { data: activeSchoolYear } = useQuery({
    queryKey: ["schoolYears"],
    queryFn: schoolYearController.getActive,
  });

  const schoolYearArr = schoolYear?.data || [];

  const selectedYear = schoolYearArr.find((year) => year.selected);

  setCurrentYear(selectedYear?.designation || currentYear);
  // Fermeture des menus lors d'un clic à l'extérieur
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      //export button
      if (
        MenuDropdownRef.current &&
        !MenuDropdownRef.current.contains(event.target as Node)
      ) {
        setIsUserMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setCurrentYear(activeSchoolYear?.data[0]?.designation || currentYear);
  }, []);

  // connected user
  const { user } = useAuth();

  return (
    <header
      className={`fixed top-0 left-60 right-0 z-50 py-4 px-6 flex items-center justify-between border-b border-solid ${
        isDarkMode ? "border-gray-700 bg-[#0D1117]" : "border-gray-200 bg-white"
      }`}
    >
      <div className="relative">
        {/* <button
          className={`block px-4 py-2 text-sm w-full text-left ${
            isDarkMode ? "hover:bg-gray-700" : "hover:bg-gray-100"
          }`}
        >
          {currentYear}
        </button> */}
        <button
          onClick={toggleYearDropdown}
          className={`flex items-center px-6 py-2 ${
            isDarkMode
              ? "bg-[#161B22] hover:bg-gray-700"
              : "bg-gray-100 hover:bg-gray-200"
          }`}
        >
          <span>{currentYear}</span>
          {/* <i className="fas fa-chevron-down ml-2"></i> */}
        </button>
        {/* {isYearDropdownOpen && (
          <div
            className={`absolute top-full left-0 mt-1 w-40 rounded-md shadow-lg ${
              isDarkMode ? "bg-[#161B22]" : "bg-white"
            } z-10`}
          >
            <div className="py-1">
            
              {schoolYearArr.map((item) => {
                return (
                  <button
                    key={item.id}
                    defaultChecked={item.selected === true}
                    onClick={() => {
                      setCurrentYear(item.designation);
                      setIsYearDropdownOpen(false);
                    }}
                    className={`block px-4 py-2 text-sm w-full text-left ${
                      isDarkMode ? "hover:bg-gray-700" : "hover:bg-gray-100"
                    }`}
                  >
                    {item.designation}
                  </button>
                );
              })}
            </div>
          </div>
        )} */}
      </div>
      <div className="flex items-center space-x-4">
        <button
          onClick={toggleDarkMode}
          className="p-2 rounded-full !rounded-button cursor-pointer whitespace-nowrap"
        >
          {isDarkMode ? (
            <LightModeOutlined className="text-yellow-400" />
          ) : (
            <i className="fas fa-moon"></i>
          )}
        </button>
        <button className="p-2 rounded-full !rounded-button cursor-pointer whitespace-nowrap">
          <i className="fas fa-bell"></i>
        </button>

        <div className="relative" ref={MenuDropdownRef}>
          <button
            id="userMenuButton"
            onClick={toggleUserMenu}
            className={`w-8 h-8 rounded-full flex items-center justify-center !rounded-button cursor-pointer whitespace-nowrap ${
              isDarkMode ? "bg-gray-700" : "bg-gray-300"
            }`}
          >
            <i className="fas fa-user"></i>
          </button>
          {isUserMenuOpen && (
            <div
              className={`absolute top-full right-0 mt-2 w-56 rounded-md shadow-lg ${
                isDarkMode ? "bg-[#161B22]" : "bg-white"
              } border ${
                isDarkMode ? "border-gray-700" : "border-gray-200"
              } z-50`}
            >
              <div className="py-1">
                <div
                  className={`px-4 py-3 border-b ${
                    isDarkMode ? "border-gray-700" : "border-gray-200"
                  }`}
                >
                  <p className="text-sm font-medium">
                    Compte{" "}
                    <span>
                      <i
                        className="fa fa-circle text-green-600 ml-1"
                        aria-hidden="true"
                      ></i>
                    </span>{" "}
                  </p>
                  <p
                    className={`text-sm ${
                      isDarkMode ? "text-gray-400" : "text-gray-500"
                    }`}
                  >
                    {user?.email}
                  </p>
                </div>
                <Link
                  to="/profil"
                  className={`w-full text-left px-4 py-2 text-sm ${
                    isDarkMode ? "hover:bg-gray-700" : "hover:bg-gray-100"
                  } flex items-center !rounded-button whitespace-nowrap`}
                >
                  <i className="fas fa-user mr-3 w-4"></i>
                  Voir le profil
                </Link>

                <Link
                  to="/parametre"
                  className={`w-full text-left px-4 py-2 text-sm ${
                    isDarkMode ? "hover:bg-gray-700" : "hover:bg-gray-100"
                  } flex items-center !rounded-button whitespace-nowrap`}
                >
                  <i className="fas fa-cog mr-3 w-4"></i>
                  Paramètres
                </Link>
                <div
                  className={`border-t ${
                    isDarkMode ? "border-gray-700" : "border-gray-200"
                  } my-1`}
                ></div>
                <button
                  className={`w-full text-left px-4 py-2 text-sm text-red-500 ${
                    isDarkMode ? "hover:bg-gray-700" : "hover:bg-gray-100"
                  } flex items-center !rounded-button whitespace-nowrap`}
                >
                  <i className="fas fa-sign-out-alt mr-3 w-4"></i>
                  Déconnexion
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
